<template>
	<div class="text-justify">
		<div class="content-wrapper">
			<app-overlay-loader v-if="preloader" />
			<div class="row">
				<!-- School History Table -->
				<div class="col-lg-12">
					<parent-interview-tab-school-school-history-table
						:value="value"
					/>
				</div>
				<app-overlay-loader v-if="preloader" />
				<!-- Form -->
				<div class="col-lg-12 mt-8">
					<form
						ref="schoolForm"
						:data-url="'/transaction/lead/' + value.id"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="row">
							<!-- Plan to move to another school in 3 years radio button -->
							<div class="col-md-12 ml-3">
								<div class="form-group row">
									<label
										for="radio_is_plan_move_school"
										class="col-lg-3"
									>
										Plan to move to another school in 3
										years:
									</label>
									<div class="col-lg-9">
										<app-input
											id="radio_is_plan_move_school"
											type="radio"
											:list="yes_and_no_list"
											v-model="
												schoolForm.is_plan_move_school
											"
										/>
									</div>
								</div>
							</div>

							<!-- Form if plan to move to another school in 3 years is yes -->
							<div
								class="col-lg-12"
								v-if="schoolForm.is_plan_move_school == 1"
							>
								<div class="row">
									<!-- Next School Name -->
									<div class="col-md-4">
										<div class="form-group">
											<label for="input_pms"
												>Next School Name</label
											>
											<app-input
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_pms"
												@input="setPlanMoveSchool"
												fetch-url="master/school"
												placeholder="School"
												list-value-field="name"
												:required="
													schoolForm.is_plan_move_school ==
													1
												"
											/>
										</div>
									</div>
									<!-- School Level -->
									<div class="col-md-4">
										<div class="form-group">
											<label for="input_pmsl">
												School Level
											</label>
											<app-input
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_pmsl"
												@input="setPlanMoveSchoolLevel"
												fetch-url="master/school-level"
												placeholder="School Level"
												list-value-field="name"
												:required="
													schoolForm.is_plan_move_school ==
													1
												"
											/>
										</div>
									</div>
									<!-- Have Chinese Lesson at School -->
									<div class="col-md-4">
										<div class="form-group">
											<label
												for="input_plan_move_chinese_basic"
												>Have Chinese Lesson at
												School</label
											>
											<app-input
												id="input_plan_move_chinese_basic"
												type="radio"
												:list="yes_and_no_list"
												v-model="
													schoolForm.plan_move_chinese_basic
												"
											/>
										</div>
									</div>
								</div>
							</div>

							<!-- Interested to study abroad radio button -->
							<div class="col-md-12 ml-3">
								<div class="form-group row">
									<label
										for="radio_is_interested_travel"
										class="col-lg-3"
									>
										Interested to study abroad:
									</label>
									<div class="col-lg-9">
										<app-input
											id="radio_is_interested_travel"
											type="radio"
											:list="yes_and_no_list"
											v-model="
												schoolForm.is_interested_travel
											"
										/>
									</div>
								</div>
							</div>

							<!-- Form if interested to study abroad is yes -->
							<div
								class="col-lg-12"
								v-if="schoolForm.is_interested_travel == 1"
							>
								<!-- Country or City of Destination -->
								<div class="form-group row align-items-center">
									<label
										class="col-md-2 mb-md-0"
										for="input_interested_countries"
									>
										Country or City of Destination
									</label>
									<app-input
										id="input_interested_countries"
										class="col-md-8"
										type="multi-select"
										:list="countryOrCityLists"
										:isAnimatedDropdown="true"
										v-model="
											schoolForm.interested_countries
										"
										placeholder="Country or City"
										:required="
											schoolForm.is_interested_travel == 1
										"
									/>
								</div>
							</div>

							<!-- Submit and Clear button -->
							<div class="mt-4 ml-4 action-buttons">
								<button
									type="submit"
									class="btn btn-primary mr-2"
									:disabled="submitSchoolFormDisabled"
									@click.prevent="submitSchoolForm"
								>
									{{ $t("submit") }}
								</button>
								<!-- <button
									type="submit"
									class="btn btn-secondary"
									@click.prevent="clearSchoolForm"
								>
									{{ $t("clear") }}
								</button> -->
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { SchoolFormMixin } from "./SchoolFormMixin.js";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	mixins: [SchoolFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			submitSchoolFormDisabled: true,
			originalSchoolForm: {},
			schoolForm: {
				is_plan_move_school: this.value.is_plan_move_school ?? 0,
				plan_move_school: this.value.plan_move_school,
				plan_move_school_level: this.value.plan_move_school_level,
				plan_move_chinese_basic:
					this.value.plan_move_chinese_basic ?? 0,
				is_interested_travel: this.value.is_interested_travel ?? 0,
				interested_countries: this.value.interested_countries,
			},
			school_name_list: [
				{ id: "school_name_1", value: "School Name 1" },
				{ id: "school_name_2", value: "School Name 2" },
				{ id: "school_name_3", value: "School Name 3" },
			],
			countryOrCityLists: [],
			yes_and_no_list: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
			input_pms: this.value
				? this.value.plan_move_school
					? {
							id: this.value.plan_move_school.id || 0,
							name: this.value.plan_move_school.name || "",
							code: this.value.plan_move_school.code,
							is_active: this.value.plan_move_school.is_active,
					  }
					: {
							id: this.value.plan_move_school?.id || 0,
							name: this.value.plan_move_school?.name || "",
							code: this.value.plan_move_school?.code,
							is_active: this.value.plan_move_school?.is_active,
					  }
				: {
						id: this.value.plan_move_school.id || 0,
						name: this.value.plan_move_school.name || "",
						code: this.value.plan_move_school.code,
						is_active: this.value.plan_move_school.is_active,
				  },
			input_pmsl: this.value
				? this.value.plan_move_school_level
					? {
							id: this.value.plan_move_school_level.id || 0,
							name: this.value.plan_move_school_level.name || "",
							code: this.value.plan_move_school_level.code,
							is_active:
								this.value.plan_move_school_level.is_active,
					  }
					: {
							id: this.value.plan_move_school_level?.id || 0,
							name: this.value.plan_move_school_level?.name || "",
							code: this.value.plan_move_school_level?.code,
							is_active:
								this.value.plan_move_school_level?.is_active,
					  }
				: {
						id: this.value.plan_move_school_level.id || 0,
						name: this.value.plan_move_school_level.name || "",
						code: this.value.plan_move_school_level.code,
						is_active: this.value.plan_move_school_level.is_active,
				  },
		};
	},
	created() {
		this.fetchData();
		this.originalSchoolForm = JSON.parse(JSON.stringify(this.schoolForm));
	},
	methods: {
		async fetchData() {
			try {
				let [countryResponse, cityResponse] = await Promise.all([
					axios.get("/master/country"),
					axios.get("/master/city?per_page=500"),
				]);

				countryResponse.data.data.forEach((item) => {
					this.countryOrCityLists.push({
						id: item.name,
						value: item.name,
					});
				});

				cityResponse.data.data.forEach((item) => {
					this.countryOrCityLists.push({
						id: item.name,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},

		// SCHOOL FORM
		beforeSubmitSchoolForm() {
			this.preloader = true;
		},
		submitSchoolForm() {
			// Handle form submission here
			const fieldsToCheck = [
				{
					condition: this.schoolForm.is_plan_move_school == 1,
					requiredFields: [
						"plan_move_school",
						"plan_move_school_level",
					],
					errorMessage: "Please select {field}",
				},
				{
					condition: this.schoolForm.is_interested_travel == 1,
					requiredFields: ["interested_countries"],
					errorMessage:
						"Please select Country or City of Destination",
				},
			];

			let allFieldsValid = true; // Assume all fields are valid initially

			// Special handling for plan_move_chinese_basic
			if (
				this.schoolForm.is_plan_move_school == 1 &&
				this.schoolForm.plan_move_chinese_basic === null
			) {
				this.schoolForm.plan_move_chinese_basic = 0; // Set a default value
			}

			for (const fieldGroup of fieldsToCheck) {
				if (fieldGroup.condition) {
					for (const field of fieldGroup.requiredFields) {
						if (!this.schoolForm[field]) {
							this.$toastr.e(
								fieldGroup.errorMessage.replace(
									"{field}",
									field.replace("_", " ")
								)
							);
							allFieldsValid = false; // Set to false if any field is not valid
						}
					}
				}
			}

			if (allFieldsValid) {
				this.originalSchoolForm = JSON.parse(
					JSON.stringify(this.schoolForm)
				);
				this.submitSchoolFormDisabled =
					JSON.stringify(this.schoolForm) ===
					JSON.stringify(this.originalSchoolForm);

				this.saveSchoolForm(this.schoolForm);
			}
		},
		afterSuccessSchoolForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearInfoForm();
		},
		afterFinalResponseSchoolForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorSchoolForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearSchoolForm() {
			// Clear form fields here
			this.schoolForm = {};
			// this.schoolForm.custom_file = null;
		},

		setPlanMoveSchool(data) {
			this.schoolForm.plan_move_school = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.schoolForm.plan_move_school = data.id;
			}
		},
		resetPlanMoveSchool() {
			this.input_pms = {};
			this.schoolForm.plan_move_school = "";
		},
		setPlanMoveSchoolLevel(data) {
			this.schoolForm.plan_move_school_level = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.schoolForm.plan_move_school_level = data.id;
			}
		},
		resetPlanMoveSchoolLevel() {
			this.input_pmsl = {};
			this.schoolForm.plan_move_school_level = "";
		},
	},
	watch: {
		schoolForm: {
			handler: function (val) {
				val.is_plan_move_school = parseInt(val.is_plan_move_school);
				val.plan_move_chinese_basic = parseInt(
					val.plan_move_chinese_basic
				);
				val.is_interested_travel = parseInt(val.is_interested_travel);

				// Check if schoolForm has changed
				const isSchoolFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalSchoolForm);

				// Update the submitSchoolFormDisabled based on the change status
				this.submitSchoolFormDisabled = !isSchoolFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
